<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import AssetRecord, { cancelRecord } from '@/model/dataLayer/api/MembershipSystem/AssetRecord'
import { showErrorMessage, showSuccessMessage } from '@/model/utils/utils'
import { useBaseFormDialogStore } from '@/model/baseForm/baseFormDialogStore'
import IKUtils from 'innerken-js-utils'

export default {
  name: 'AssetRecord',
  components: {
    IkDataTable
  },
  data () {
    return {
      recordDetail: null,
      model: AssetRecord
    }
  },
  async mounted () {
    await this.reload()
  },
  computed: {
    schemas () {
      return [
        {
          key: 'revokedBy',
          name: 'revokedBy',
          hint: '撤销操作执行人',
          required: true,
          componentProps: {
            placeholder: '请输入撤销操作执行人姓名'
          }
        },
        {
          key: 'reason',
          name: 'reason',
          hint: '撤销原因',
          required: true,
          componentProps: {
            placeholder: '请输入撤销原因',
            rules: [v => !!v || '撤销原因不能为空', v => v.length <= 200 || '撤销原因不能超过200个字符']
          }
        }
      ]
    },
    getStatusColor () {
      return (status) => {
        if (status === 'DISTRIBUTED') return 'info'
        if (status === 'USED') return 'green'
        if (status === 'EXPIRED') return 'red'
        return ''
      }
    }
  },
  methods: {
    async submitRevoke (info) {
      await cancelRecord(this.recordDetail.id, info)
      showSuccessMessage('撤销成功！')
      await this.$refs.table.reload()
    },
    async removeRecord (item) {
      try {
        // Deep copy the item to avoid modifying the original
        this.recordDetail = IKUtils.deepCopy(item)

        const store = useBaseFormDialogStore()

        // Define the schema for the revoke dialog
        const schema = {
          title: '撤销记录',
          subtitle: '请输入撤销原因',
          schemas: this.schemas
        }

        // Open the dialog and wait for the result
        const result = await store.editItem(schema)

        // Handle the result
        if (result) {
          await this.submitRevoke(result)
        }
      } catch (error) {
        console.error('Error revoking record:', error)
        showErrorMessage('撤销记录失败: ' + (error.message || '未知错误'))
      }
    },
    async reload () {

    }
  }
}
</script>

<template>
  <v-container>
    <ik-data-table
      ref="table"
      :model="model"
      :use-default-action="false"
      entity-name="资产记录"
      icon="mdi-cash-usd"
    >
      <template #item.operation="{item}">
        <div class="d-flex">
          <v-tooltip
            bottom
            color="grey lighten-4"
          >
            <template #activator="{on,attrs}">
              <div
                class="d-flex align-center"
                v-bind="attrs"
                v-on="on"
              >
                <v-btn
                  v-if="item.status === 'DISTRIBUTED'"
                  elevation="0"
                  icon
                  small
                  @click.stop="removeRecord(item)"
                >
                  <v-icon>
                    mdi-reload
                  </v-icon>
                </v-btn>
              </div>
            </template>
            <div
              class="text-caption text--secondary"
            >
              {{ '撤销记录' }}
            </div>
          </v-tooltip>
        </div>
      </template>
      <template #item.statusDisplay="{item}">
        <v-chip
          :color="getStatusColor(item.status)"
          dark
        >
          {{ item.status }}
        </v-chip>
      </template>
    </ik-data-table>

    <!-- BaseFormDialog is used for the revoke dialog -->
  </v-container>
</template>

<style scoped>

</style>
